import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_2 = { class: "control-label col-sm-6" }
const _hoisted_3 = { class: "col-sm" }
const _hoisted_4 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_5 = { class: "control-label col-sm-6" }
const _hoisted_6 = { class: "col-sm" }


export default {
  __name: 'AliquoteContributiRepertoriali',
  props: {
  validazione: {
    type: [Object],
    default: {}
  },
  helper: {
    type: [Object,String],
    default: {}
  },
  readonly:{
    type: Boolean,
    default:false
  }
},
  setup(__props) {

const props = __props;

return (_ctx, _cache) => {
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "crm:my-0 crm:bg-secondary" }, null, -1 /* CACHED */)),
    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "crm:font-bold! crm:uppercase crm:mb-3! crm:mt-4!" }, "ALIQUOTE CONTRIBUTIVE REPERTORIALI ADDIZIONALI", -1 /* CACHED */)),
    _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "crm:my-0 crm:bg-secondary crm:mb-4!" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.validazione.fondo_di_garanzia.label), 1 /* TEXT */)
      ])), [
        [_directive_fallcohelper, __props.helper.calcolo.fondo_di_garanzia.ref]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_input_text, {
          id: "fondo_di_garanzia",
          name: "fondo_di_garanzia",
          class: "placeholder-right crm:text-right",
          placeholder: "0.00",
          disabled: __props.readonly,
          "validate-to": __props.validazione.fondo_di_garanzia ,
          "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((__props.validazione.fondo_di_garanzia ) = $event))
        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_5, [
        _createTextVNode(_toDisplayString(__props.validazione.aliquota_aggiuntiva.label), 1 /* TEXT */)
      ])), [
        [_directive_fallcohelper, __props.helper.calcolo.aliquota_aggiuntiva.ref]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_base_input_text, {
          id: "aliquota_aggiuntiva",
          name: "aliquota_aggiuntiva",
          class: "placeholder-right crm:text-right",
          placeholder: "0.00",
          disabled: __props.readonly,
          "validate-to": __props.validazione.aliquota_aggiuntiva,
          "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((__props.validazione.aliquota_aggiuntiva) = $event))
        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

}